import axios from "axios";

export const lookupMgmtUnitTypes = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/managementunittypes`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
